<template><span>
    <template v-if="price">
        <strong>{{formatPrice(price.v[0])}} 
            <span :title="title()">
                {{symb(price.v[1])}}
            </span>
        </strong>
        <template v-if="!props.sum"> / чел.</template>
    </template>
    <template v-else><strong>-- ---  </strong></template>
</span></template>

<script setup>
import { formatPrice } from '@/util.js'
import { _get } from '@/actions.js'

const props = defineProps({
    price : Object, 
    sum: {
        type: Boolean,
        default: false,
    },
})

const title = () => {
    let a
    let t = []
    a = _get(props.price, 'tariff.name')
    if (a) {
        t.push(`тариф: ${a}`)
    }
    a = _get(props.price, 'id')
    if (a) {
        t.push(`код: ${a}`)
    }
    a = _get(props.price, 'src')
    if (a) {
        t.push(`источник: ${a}`)
    }
    let ret = t.length ? t.join(', ') : null
    return ret
}


const CURRENCY_SYMBOL = {
    "1" : 'руб.', // ₽
    "2" : 'usd',
    "3" : 'eur',
}

const symb = (c) => {
    return CURRENCY_SYMBOL[c]
}

</script>